import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';

// Import routes configuration
import AppRoutes from './routes';

/**
 * Componente principal de la aplicación
 */
function App() {
  return (
    <Router>
      <div className="App">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
